<template>
  <b-row v-if="details">
    <!-- Summary Starts-->
    <b-col cols="12">
      <b-row :class="`details-header-container${details.videoLabel? ' details-header-section-exist' : ''}`">
        <video-details-title
          v-if="details"
          :title-data="details"
          @closeDetails="closeDetails"
        />

        <!-- Engagement Starts -->
        <video-details-engagement
          v-if="details"
          :engagement-data="details"
        />
        <!-- Engagement Ends -->
      </b-row>
    </b-col>
    <!-- Summary Ends-->

    <!-- User Interactions Starts-->
    <b-col
      v-if="details"
      xl="6"
      md="12"
      sm="12"
    >
      <video-details-user-interactions
        :ui-data="details"
      />
    </b-col>
    <!-- User Interactions Ends-->

    <!-- Play Times Starts-->
    <b-col
      v-if="ptData"
      xl="6"
      md="12"
      sm="12"
    >
      <video-details-video-played-times
        :pt-data="ptData"
      />
    </b-col>
    <!-- Play Times Ends-->

    <!-- Video Jumps Starts-->
    <b-col
      v-if="vjData && false"
      xl="12"
      md="12"
      sm="12"
    >
      <video-details-video-jumps
        :vj-data="vjData"
      />
    </b-col>
    <!-- Video Jumps Ends-->

    <!-- Video Displays Starts-->
    <b-col
      v-if="vdData"
      xl="12"
      md="12"
      sm="12"
    >
      <video-details-video-displays
        :vd-data="vdData"
      />
    </b-col>
    <!-- Video Displays Ends-->
  </b-row>
</template>

<script>
import {
    BRow, BCol,
} from 'bootstrap-vue'
import VideoDetailsTitle from '@/views/components/videoDetails/sections/live/VideoDetailsTitle.vue'
import VideoDetailsEngagement from '@/views/components/videoDetails/sections/live/VideoDetailsEngagement.vue'
import VideoDetailsVideoPlayedTimes from '@/views/components/videoDetails/sections/live/VideoDetailsVideoPlayedTimes.vue'
import VideoDetailsVideoDisplays from '@/views/components/videoDetails/sections/live/VideoDetailsVideoDisplays.vue'
import VideoDetailsUserInteractions from '@/views/components/videoDetails/sections/live/VideoDetailsUserInteractions.vue'
import VideoDetailsVideoJumps from '@/views/components/videoDetails/sections/live/VideoDetailsVideoJumps.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
const moment = require('moment')

export default {
    components: {
        VideoDetailsTitle,
        VideoDetailsEngagement,
        VideoDetailsVideoPlayedTimes,
        VideoDetailsVideoDisplays,
        VideoDetailsUserInteractions,
        VideoDetailsVideoJumps,
        BRow,
        BCol,

    },
    props: {
        details: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            ptData: null,
            vdData: null,
            vjData: null,
        }
    },
    watch: {
        details() {
            this.initDetails()
        },
    },
    created() {
        this.initDetails()
    },
    methods: {
        initDetails() {
            if (this.details) {
                // Video Played Times Starts
                if (this.details.playedTimes) {
                    const playedTimes = JSON.parse(this.details.playedTimes)
                    const playedTimesList = {
                        100: {
                            left: '100 %',
                            bar: 0,
                            right: 0,
                        },
                        75: {
                            left: '75 %',
                            bar: 0,
                            right: 0,
                        },
                        50: {
                            left: '50 %',
                            bar: 0,
                            right: 0,
                        },
                        25: {
                            left: '25 %',
                            bar: 0,
                            right: 0,
                        },
                    }

                    playedTimes.sort((a, b) => a.px - b.px)
                    let playedTimesTotal = 0
                    playedTimes.forEach(obj => {
                        playedTimesTotal += obj.dy
                    })

                    let playedTotalDes = playedTimesTotal
                    let prevObject = null

                    playedTimes.forEach(obj => {
                        if (prevObject) {
                            playedTotalDes -= prevObject.dy
                        }
                        // eslint-disable-next-line radix
                        playedTimesList[obj.px] = {
                            left: `${obj.px} %`,
                            // eslint-disable-next-line no-mixed-operators
                            bar: Math.round(playedTotalDes / playedTimesTotal * 100),
                            right: playedTotalDes,
                        }
                        prevObject = obj
                    })

                    this.ptData = {
                        title: 'Watch Durations (30 min)',
                        tableLeftTitle: 'Percentage',
                        tableRightTitle: 'Times',
                        list: playedTimesList,
                    }
                } else {
                    this.ptData = null
                }

                // Video Displays Starts
                if (this.details.videoDisplays) {
                    const displays = this.details.videoDisplays

                    displays.sort((a, b) => b.videoPlayCount - a.videoPlayCount)

                    const displayList = []
                    displays.forEach(display => {
                        const displayData = { ...display }
                        displayData.videoPlayedTimeAvgFormated = moment.utc(displayData.videoPlayedTimeAvg * 1000).format('HH:mm:ss')
                        displayData.videoJumpRangeTotal = moment.utc(displayData.videoJumpRangeTotal * 1000).format('HH:mm:ss')
                        displayData.videoJumpRangeForwardTotal = moment.utc(displayData.videoJumpRangeForwardTotal * 1000).format('HH:mm:ss')
                        displayData.videoJumpRangeBackwardTotal = moment.utc(displayData.videoJumpRangeBackwardTotal * 1000).format('HH:mm:ss')
                        if (displayData.refererDomains) {
                            displayData.refererDomains.sort((a, b) => b.refererCount - a.refererCount)
                        }
                        displayList.push(displayData)
                    })

                    this.vdData = {
                        title: 'Video Displays (30 min)',
                        list: displayList,
                    }
                } else {
                    this.vdData = null
                }
                // Video Displays End

                // Video Jumps Starts
                if (this.details.videoJumps) {
                    const forwardJumps = this.details.videoJumps || []
                    const backwardJumps = this.details.videoBackwardJumps ? this.details.videoBackwardJumps : []
                    // console.log('forwardJumps', forwardJumps)
                    // console.log('backwardJumps', backwardJumps)
                    forwardJumps.sort((a, b) => b.count - a.count)

                    const forwardJumpList = []
                    forwardJumps.forEach(jump => {
                        const jumpData = { ...jump }
                        jumpData.time = moment.utc(jumpData.time * 60 * 1000).format('HH:mm:ss')
                        forwardJumpList.push(jumpData)
                    })

                    const backwardJumpList = []

                    backwardJumps.sort((a, b) => b.count - a.count)

                    backwardJumps.forEach(jump => {
                        const jumpData = { ...jump }
                        jumpData.time = moment.utc(jumpData.time * 60 * 1000).format('HH:mm:ss')
                        backwardJumpList.push(jumpData)
                    })

                    this.vjData = {
                        title: 'Video Jumps (30 min)',
                        videoJumpRangeTotal: moment.utc(this.details.videoJumpRangeTotal* 1000).format('HH:mm:ss'),
                        videoJumpRangeForwardTotal: moment.utc(this.details.videoJumpRangeForwardTotal * 1000).format('HH:mm:ss'),
                        videoJumpRangeBackwardTotal: moment.utc(this.details.videoJumpRangeBackwardTotal * 1000).format('HH:mm:ss'),
                        jumpCount: this.details.jumpCount,
                        jumpUserCount: this.details.jumpUserCount,
                        jumpForwardCount: this.details.jumpForwardCount,
                        jumpBackwardCount: this.details.jumpBackwardCount,
                        forwardJumpList,
                        backwardJumpList,
                    }
                } else {
                    this.vjData = null
                }
                // Video Jumps End
            }
        },
        isMobile() {
            return window.innerWidth < 768
        },
        closeDetails() {
            this.$emit('closeDetails')
        },
    },
}
</script>
